import React, { useEffect, useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";

const STORAGE_KEY = "theme";
const THEME_COLORS = { light: "#ffffff", dark: "#1d2126" };

// Startwert kommt aus public/index.html (wird dort vor dem ersten Rendern gesetzt)
function getInitialTheme() {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", THEME_COLORS[theme]);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {}
  }, [theme]);

  const isDark = theme === "dark";
  const label = isDark ? "Zum hellen Modus wechseln" : "Zum dunklen Modus wechseln";

  return (
    <button
      type="button"
      className="icon-btn theme-toggle"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={label}
      title={label}
    >
      {isDark ? <FaSun /> : <FaMoon />}
    </button>
  );
}
